/* eslint-disable no-confusing-arrow */
import React, { PropsWithChildren, Ref } from 'react';
import classNames from 'classnames';
import styles from './Menu.module.css';
import { BaseProps } from '../../../types';

interface Props {
  open: boolean;
}
// top: ${(props) => props.open ? '0px' : '-10000px'};
// const MenuDiv = styled.div<Props>`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: center;
//   position: absolute;
//   z-index: 999;
//   left: -10000px;
//   margin-top: -6px;
//   opacity: ${(props) => props.open ? 1 : 0};
//   background-color: var(--background-button);
//   box-shadow: var(--shadow-modal);
//   border-radius: 4px;
//   transition: opacity 0.25s;
// `;

const Menu = React.forwardRef(
  (
    { className, ...props }: PropsWithChildren<BaseProps & Props>,
    ref?: Ref<HTMLDivElement>,
  ) => (
    <div
      {...props}
      ref={ref}
      className={classNames(className, styles.Menu)}
    />
  ),
);
export default Menu;
